import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IGenerateFilenameResponse {
  fileName: string;
  warnings?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class GenerateFilenameService {
  constructor(private http: HttpClient) {
  }

  generateFilename(namespace: string, proposed: string): Observable<IGenerateFilenameResponse> {
    const url = `${environment.kpHost}/file/${namespace}/generatefilename?proposed=${proposed}`;
    return this.http.get<IGenerateFilenameResponse>(url);
  }
}
